export default __webpack_public_path__ + "static/media/maithri_goonetilleke.15b873cf.jpg";